<template>
  <div class="ml-3">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          :exportFileName="title"
          @on-add-click="add"
        >
          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </a>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="deleteItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </a>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editPluginRights(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="blue">mdi-security</v-icon>
                </a>
              </template>
              <span>{{ $t("AccessRights") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a v-on="on" @click.prevent="activate(row.data.item)">
                  <v-icon v-if="!row.data.item.IsActive" color="red"
                    >mdi-power-plug-off</v-icon
                  >
                  <v-icon v-if="row.data.item.IsActive" color="green"
                    >mdi-power-plug</v-icon
                  >
                </a>
              </template>
              <span>
                {{ row.data.item.IsActive ? $t("Deactivate") : $t("Activate") }}
              </span>
            </v-tooltip>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
    <PluginModal :ref="modalKey" @on-item-saved="onItemSaved" />
    <PluginRightsModal :ref="pluginRightsModalKey" />
  </div>
</template>

<script>
import PluginService from "@/services/PluginService";
import PluginModal from "@/components/administration/plugin/PluginModal.vue";
import PluginRightsModal from "@/components/administration/plugin/PluginRightsModal.vue";
import Utils from "@/ecm/common/Utils";

export default {
  components: {
    PluginModal,
    PluginRightsModal,
  },
  data() {
    return {
      title: this.$t("Plugins"),
      grid: {
        key: "pluginGrid",
        dataSource: PluginService.getGrid(),
        columns: [
          {
            field: "Name",
            caption: this.$t("Name"),
            type: "string",
          },
          {
            field: "ContentTypesNames",
            caption: this.$t("ContentTypes"),
            type: "string",
          },
          {
            field: "LocationName",
            caption: this.$t("Location"),
            type: "string",
          },
          {
            field: "Icon",
            caption: this.$t("Icon"),
            type: "string",
          },
        ],
      },
      modalKey: "modalPlugin",
      pluginRightsModalKey: "pluginRightsModalKey",
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modalKey];
    },
    pluginRightsModalInstance() {
      return this.$refs[this.pluginRightsModalKey];
    },
    gridInstance() {
      return this.$refs[this.grid.key];
    },
  },
  methods: {
    editItem(dto) {
      this.modalInstance.edit(dto);
    },
    editPluginRights(dto) {
      this.pluginRightsModalInstance.edit(dto);
    },
    activate(dto) {
      PluginService.activate(dto.Id).then((result) => {
        this.gridInstance.refresh();
      });
    },
    deleteItem(dto) {
      this.$confirm(this.$t("ItemDeleteConfirmation"), {
        title: this.$t("Delete"),
        icon: "mdi-alert",
        color: "red",
        buttonTrueText: this.$t("Delete"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          PluginService.delete(dto.Id).then((result) => {
            if (result) {
              this.gridInstance.refresh();
              Utils.toast.success("Plugin " + this.$t("DeletedSuccessfully"));
            }
          });
        }
      });
    },
    add() {
      this.modalInstance.new();
    },
    onItemSaved() {
      this.gridInstance.refresh();
    },
  },
};
</script>
